<script lang="ts">
  import { isDirectionRTL } from '../../../../common/util';
  import Text from '../../../common/components/Text.svelte';

  export let optionPrice;
  export let discountedPrice;
  export let currency;
  const isRTL = isDirectionRTL();
</script>

<section class="extra-service-discount-section">
  <div class="option-price">
    <div class:ar-price={isRTL}>
      {currency}
      <strong><Text key={discountedPrice} /></strong>
    </div>
    /
    <div class="strike-price" class:ar-price={isRTL}>
      {currency}
      <strong><Text key={optionPrice} /></strong>
    </div>
  </div>
</section>

<style lang="scss">
  @import '../../../common/styles/colors.new.scss';

  .extra-service-discount-section {
    .option-price {
      gap: 4px;
      text-align: end;
      color: $neutral-dark-01;
      font-weight: 400;
      font-size: 14px;
      line-height: 18px;
      white-space: nowrap;
      display: flex;
      flex-direction: row;
      justify-content: flex-end;
      @include desktop-min-width {
        color: $neutral-dark-01;
        font-size: 16px;
      }
    }
    .ar-price {
      display: flex;
      flex-direction: row-reverse;
    }
    .strike-price {
      text-decoration: line-through;
    }
  }
</style>
